import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API } from '../data/constants';

import { UnsereSchuleType } from '../types/types';

export const useUnsereSchuleData = () => {
  return useQuery<UnsereSchuleType, Error>({
    queryKey: ['unsereSchuleData'],
    queryFn: () => axios.get(`${API.general}/unsere-schule-neu?populate[unterricht][populate]=*&populate[leitbild][populate][herzbildung][populate]=*&populate[leitbild][populate][kopfbildung][populate]=*&populate[verpflichtungsangebote][populate][icons][populate]=*&populate[nachmittagsangebote][populate][icons][populate]=*&populate[montag][populate]=*&populate[dienstag][populate]=*&populate[mittwoch][populate]=*&populate[donnerstag][populate]=*&populate[freitag][populate]=*&populate[images][populate]=*&populate[hero][populate]=*`)
                        .then(res => res.data.data.attributes)
  });
};

